module.exports = __webpack_public_path__ + "static/media/LOGO SIMMONS STORE Mayo2019_transparente_BLANCO.a484bfab.png";